const PDF_PUBLIC_ASSET_ROOT = 'ember-simplepractice/pdfjs';

export function webpackPublicPath() {
  // Webpack replaces this identifier with the runtime public path (CDN +
  // PUBLIC_ASSET_PREFIX). Keep it as a bare identifier so the replacement
  // still happens after Rollup emits this file.
  // eslint-disable-next-line camelcase, no-undef
  return typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : '';
}

export function publicAssetBaseUrl(publicPath = webpackPublicPath()) {
  let origin = `${globalThis.location?.origin ?? 'https://localhost'}/`;
  let path = !publicPath || publicPath === 'auto' ? '' : publicPath;
  let normalizedPath = path.endsWith('/') || path === '' ? path : `${path}/`;
  let base = new URL(normalizedPath, origin).href;

  // The bundler public path ends in its output directory (`…/frontend/assets/`).
  // Addon public files are uploaded at the deploy prefix, beside that directory
  // (`…/frontend/ember-simplepractice/…`), so drop the extra `assets/` segment.
  //
  // Staging's prefix is already `{namespace}.staging/assets`, and the files are
  // uploaded under it. That trailing `assets` is the prefix, not an output
  // directory, so it has to stay.
  if (/^(?:[a-z]+:)?\/\/[^/]+\/[^/]+\.staging\/assets\/$/i.test(base)) {
    return base;
  }

  return base.replace(/assets\/$/, '');
}

export function pdfRuntimeAssetUrl(directory, publicPath) {
  let assetPath = `${PDF_PUBLIC_ASSET_ROOT}/${directory}/`;

  try {
    return new URL(assetPath, publicAssetBaseUrl(publicPath)).href;
  } catch {
    return `${globalThis.location?.origin ?? ''}/${assetPath}`;
  }
}

export function pdfRuntimeFileUrl(directory, fileName, publicPath) {
  try {
    return new URL(fileName, pdfRuntimeAssetUrl(directory, publicPath)).href;
  } catch {
    return `${pdfRuntimeAssetUrl(directory, publicPath)}${fileName}`;
  }
}
